import React, { Component, useState, useEffect, Fragment, Suspense } from 'react'
import axios from 'axios';
import { useParams, useHistory } from 'react-router-dom';
import { snowmindsConfig } from '../../configuration';
import { lazy } from 'react';
import TravelDocumentSkeleton from '../../skeleton/TravelDocumentSkeleton';
import { utils } from '../../utils/utils';
import ReactGA from 'react-ga';


ReactGA.set({ page: window.location.pathname }); // Update the user's current page
ReactGA.pageview(window.location.pathname + window.location.search); // Record a pageview for the given page

const TravelDocument = (props) => {

    const [traveldocument, settraveldocument] = useState({});
    const params = useParams();
    const history = useHistory();
    useEffect(() => {
        utils.removeNavFromCheckoutPages();

        const traveldocid = params.traveldocid && params.traveldocid.match('tid')
            && params.traveldocid.match('tid').index !== -1 ? params.traveldocid.replace('tid-', '') : params.traveldocid;

        if (traveldocid !== 0)
            fetchTraveldoc(traveldocid)
        else
            history.push(
                {
                    pathname: '/404'
                }
            )

    }, [])
    const fetchTraveldoc = (traveldocid) => {
        let snowminds = snowmindsConfig.getSnowMindsConfiguration();
        const url = snowminds.travelDoc.getApi;//`http://snowmindstest.s.cmshelp.dk/checkout/traveldocument`;// `${snowminds.gettraveldocument}`;
        let param = {
            tid: traveldocid || 0,
            pageId: document.getElementById("hdPageId").value,
            brand: document.getElementById("hdBrand").value,
            language: document.getElementById("hdLanguage").value
        }
 
   
        axios.get(url, { params: param }
            , {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            })
            .then(res => {
          
                //(res + `traveldocumentdata`)
                if(res.data && res.data.statusCode==="200" && res.data.isValid)
                {
                    settraveldocument(res.data);
                }else{
                    const {url='/'}=props.homePageUrl;
                  history.replace(url);
                }
                document.title = res.data && res.data.pageTitle? res.data.pageTitle : `Travel-Document`;
                document.body.style.opacity = "1";

            })
            .catch(err => {  });
    }
  


    if (traveldocument && traveldocument.hasOwnProperty('participants')) {
        const TravelDocWrapperComponent = lazy(() => import('./TravelDocWrapper'));
        const HeaderComponent = lazy(() => import('./Header/Header'));
        return (
            <Suspense fallback={<TravelDocumentSkeleton></TravelDocumentSkeleton>}>
                <Fragment>
                    <HeaderComponent traveldocument={traveldocument} homePageUrl={props.homePageUrl}/>
                    <section className="static-page-wrapper">
                        <div className="static-width">
                            <div className="static-page">
                                <TravelDocWrapperComponent traveldocument={traveldocument} />

                            </div>

                        </div>

                    </section>
                </Fragment>
            </Suspense>

        )
    } else
        return (
            <TravelDocumentSkeleton></TravelDocumentSkeleton>
        )

}

export default  TravelDocument
